import { Component, OnInit } from '@angular/core';
import { AppService } from '../services/app.service';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.css']
})
export class ForbiddenComponent implements OnInit {
  ErrorMsg: any;
  DisplayText: string;
  DisplayDuring: string;
  DisplayCase = "403";

  constructor(private appService: AppService) {
    this.DisplayText = 'Forbidden !';
  }

  ngOnInit() {
    this.ErrorMsg = this.appService.ErrMsg.subscribe(x => {
      this.DisplayText = x
    });
    if (window['config'].Maintenance == true) {
      this.DisplayCase = "Maintenance";
      if (window['config'].MaintenanceDuring) {
        this.DisplayDuring = "During : " + window['config'].MaintenanceDuring;
      }
      this.DisplayText = window['config'].MaintenanceContext;
    }
  }

  ngOnDestroy() {
    this.appService.SetErrMsg('');
    this.ErrorMsg.unsubscribe();
  }
}
